<template>
  <!-- login form -->

  <form @submit.prevent="checkServer">

    <div class="login-create">

      <div class="form-group ">
        <!--<label for="name" class="float-left">Nombres</label>-->
        <input
          type="text"
          :class="'form-control login__input sen-form-input-with-tooltip ' + validateName"
          :maxlength="50"
          id="firstname"
          aria-describedby="firstname"
          placeholder="Ingresa tu nombre"
          v-model="name"
          required
        >

        <div class="sen-tooltip sen-tooltip-create ">
          <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa</span>
        </div>

        <small v-if="responseName" class="text-danger d-flex align-items-start">{{responseName}}</small>

      </div>

      <div class="form-group ">
        <!--<label for="name" class="float-left">Apellidos</label>-->
        <input
          type="text"
          :class="'form-control login__input sen-form-input-with-tooltip ' + validateLast"
          :maxlength="100"
          id="lastname"
          aria-describedby="lastname"
          placeholder="Ingresa tus apellidos"
          v-model="lastname"
          required
        >

        <div class="sen-tooltip sen-tooltip-create ">
          <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa</span>
        </div>

        <small v-if="responseLast" class="text-danger d-flex align-items-start">{{responseLast}}</small>

      </div>

      <div class="form-group">
        <!--<label for="email" class="float-left">Correo Electrónico</label>-->
        <input
          type="email"
          :class="'form-control login__input sen-form-input-with-tooltip ' + validateUser"
          id="email"
          aria-describedby="email"
          placeholder="Ingresa tu email"
          v-model="username"
          required
        >

        <div class="sen-tooltip sen-tooltip-create ">
          <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa</span>
        </div>

        <small v-if="responseUser" class="text-danger d-flex align-items-start">{{responseUser}}</small>

      </div>

      <div class="form-group">
        <!--<label for="phone" class="float-left">N° Teléfono</label>-->
        <input
          type="tel"
          :class="'form-control login__input sen-form-input-with-tooltip' + validatePhone"
          :maxlength="9"
          id="phone"
          aria-describedby="phone"
          v-model="telephone"
          v-digitsonly
          placeholder="Numero de telefono"
          required
        >

        <div class="sen-tooltip sen-tooltip-create">
          <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa</span>
        </div>

        <small v-if="responsePhone!=''" class="text-danger d-flex align-items-start">{{responsePhone}}</small>

      </div>

      <div class="form-group">
        <!--<label for="genre" class="float-left">Sexo:</label>-->
        <select
          name="sexo"
          id="genre"
          :class="'custom-select form-control login__input sen-form-input-with-tooltip ' + validateGenre"
          v-model="sexo"
          required
        >
          <option value="0">Sexo</option>
          <option value="1">Masculino</option>
          <option value="2">Femenino</option>
        </select>

        <div class="sen-tooltip sen-tooltip-create ">
          <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa</span>
        </div>

        <small v-if="responseGenre" class="text-danger d-flex align-items-start">{{responseGenre}}</small>

      </div>

      <div class="form-group">
        <!--<label for="date" class="float-left">Fecha de nacimiento (18+):</label>-->
        <input
        id="date"
          type="date"
          :class="'form-control login__input sen-form-input-with-tooltip ' + validateDate"
          v-model="date"
          placeholder="Fecha de nacimiento"
          onkeydown="return false"
          required
        >

        <div class="sen-tooltip sen-tooltip-create ">
          <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa</span>
        </div>

        <small v-if="responseDate" class="text-danger d-flex align-items-start">{{responseDate}}</small>

      </div>

      <div class="form-group">
        <!--<label for="password" class="float-left">Contraseña</label>-->
        <input
          type="password"
          :class="'form-control login__input sen-form-input-with-tooltip ' + validatePass"
          id="password"
          placeholder="Contraseña"
          v-model="password"
          required
        >

        <div class="sen-tooltip sen-tooltip-create ">
          <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa</span>
        </div>

        <small v-if="responsePass" class="text-danger d-flex align-items-start">{{responsePass}}</small>
        <small v-if="response2Pass" class="text-danger d-flex align-items-start">{{response2Pass}}</small>

      </div>

      <div class="form-group">
        <!--<label for="password2" class="float-left">Repetir contraseña</label>-->
        <input
          type="password"
          :class="'form-control login__input sen-form-input-with-tooltip ' + validateCheck"
          id="password2"
          placeholder="Repita contraseña"
          v-model="checkPassword"
          required
        >

        <div class="sen-tooltip sen-tooltip-create ">
          <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa</span>
        </div>

        <small v-if="responseCheck" class="text-danger d-flex align-items-start">{{responseCheck}}</small>

      </div>

      <button
        type="submit"
        id="submit"
        :class="'btn btn-primary mt-4 btn-lg btn-block btn-round  ' + loading"
      >Continuar</button>
      <!-- <router-link
        to="/correct"
        :class="'btn btn-primary mt-4 btn-lg btn-block ' + loading"
      >Continuar</router-link>-->
    </div>
    <!-- errors -->
    <div v-if="response">
      <p class="text-danger">{{response}}</p>
    </div>
  </form>




</template>

<script>
/* eslint-disable */
/* import api from '../api' */
import axios from 'axios'
// document.addEventListener('DOMContentLoaded', function(event) {
//   var input = document.querySelector('#phone')
//   window.intlTelInput(input, {
//     utilsScript:
//       'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/14.0.5/js/utils.js',
//     autoPlaceholder: 'aggresive',
//     initialCountry: 'PE',
//     preferredCountries: ['PE', 'AR', 'US']
//     /* initialCountry: "auto"
//                geoIpLookup: function (success, failure) {
//                     $.get("https://ipinfo.io", function () {}, "jsonp").always(function (resp) {
//                       var countryCode = (resp && resp.country) ? resp.country : "";
//                       success(countryCode);
//                     });
//         } */
//   })
// })
export default {
  name: 'CreateAccount',
  data(router) {
    return {
      section: 'Create',
      loading: '',
      name: '',
      validateName: '',
      responseName: '',
      lastname: '',
      validateLast: '',
      responseLast: '',
      username: '',
      validateUser: '',
      responseUser: '',
      password: '',
      validatePass: '',
      responsePass: '',
      response2Pass: '',
      response: '',
      checkPassword: '',
      validateCheck: '',
      responseCheck: '',
      telephone: '',
      validatePhone: '',
      responsePhone: '',
      sexo: 0,
      validateGenre: '',
      responseGenre: '',
      date: '',
      validateDate: '',
      responseDate: ''
    }
  },
  methods: {
    checkServer() {
      let self = this
      let url = ''
      this.toggleLoading()
      this.$store.commit('TOGGLE_LOADING')
      this.resetResponse()
      if (this.validateForm()) {
        this.resetResponse()
        url = process.env.API_URL + '/api/client/create-client'
        axios
          .post(url, {
            name: this.name,
            surnames: this.lastname,
            country_code: '+51',
            cellphone: this.telephone,
            gender: this.sexo === 1 ? 'M' : 'F',
            birthdate: this.date,
            email: this.username,
            password: this.password
          })
          .then(response => {
            self.toggleLoading()
            console.log('success')
            console.log(response.data)
            if (response.data.status) {
              self.$router.push('/correct')
            }
          })
          .catch(error => {
            let responseMessage
            let errorFlag
            if (error.response) {
              if (error.response.status === 400) {
                self.response = 'Error 400'
              } else if (error.response.status === 404) {
                self.response = 'Error 404'
              } else if (
                error.response.status === 422 ||
                error.response.status === 401
              ) {
                console.log('entro')
                /* self.response = 'Errores de validación, por favor, vuelve a intentarlo' */
                if (error.response.data.errors.hasOwnProperty('email')) {
                  responseMessage = error.response.data.errors.email[0]
                  console.log(responseMessage)
                  errorFlag = parseInt(
                    responseMessage.substr(0, responseMessage.indexOf('.'))
                  )
                  if (errorFlag === 1) {
                    self.validateUsername('emailInc')
                  }
                } else if (
                  error.response.data.errors.password[0]
                    .slice(0, 1)
                    .toString() === '2'
                ) {
                  let passInc = 'passInc'
                  self.validateUser(passInc)
                }
              } else if (error.response.status === 500) {
                self.response = 'Error de servidor. Inténtelo más tarde.'
              } else {
                self.response = 'Error inesperado'
              }
            } else if (error.request) {
              console.log(error.request)
            } else {
              console.log('Error', error.message)
            }
            console.log(error.config)
          })
      }
      this.validation = null
    },
    toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse() {
      this.response = ''
      this.validateName = ''
      this.responseName = ''
      this.validateLast = ''
      this.responseLast = ''
      this.validateUser = ''
      this.responseUser = ''
      this.validatePass = ''
      this.responsePass = ''
      this.response2Pass = ''
      this.validateCheck = ''
      this.responseCheck = ''
      this.validatePhone = ''
      this.responsePhone = ''
      this.validateGenre = ''
      this.responseGenre = ''
      this.validateDate = ''
      this.responseDate = ''
    },
    validateForm() {
      console.log(
        this.name,
        this.lastname,
        this.username,
        this.password,
        this.checkPassword,
        this.telephone,
        this.sexo,
        this.date
      )
      let name = 'name'
      let last = 'last'
      let pass = 'pass'
      let check = 'check'
      let names = this.validateNames(name)
      let surnames = this.validateNames(last)
      let user = this.validateUsername()
      let phone = this.validateNumber()
      let genre = this.validateSex()
      let birthdate = this.validateBday()
      let pass1 = this.validatePassword(pass)
      let pass2 = this.validatePassword(check)
      let checkPass = this.validate2Password()
      return (
        names &&
        surnames &&
        user &&
        phone &&
        genre &&
        birthdate &&
        pass1 &&
        pass2 &&
        checkPass
      )
    },
    validateNames(atr) {
      if (atr === 'name') {
        this.validateName =
          this.name.length < 1 || this.name.length > 50
            ? 'incorrect'
            : 'correct'
        this.responseName =
          this.name.length < 1 || this.name.length > 50
            ? 'Nombres debe contener entre 1 y 50 carácteres.'
            : ''
        return !(this.name.length < 1 || this.name.length > 50)
      } else if (atr === 'last') {
        this.validateLast =
          this.lastname.length < 1 || this.lastname.length > 100
            ? 'incorrect'
            : 'correct'
        this.responseLast =
          this.lastname.length < 1 || this.lastname.length > 100
            ? 'Apellidos deben contener entre 1 y 100 carácteres.'
            : ''
        return !(this.lastname.length < 1 || this.lastname.length > 100)
      }
    },
    validateUsername(atr = null) {
      if (atr === null) {
        let aux = new RegExp('[\\w+\\-\\.]+\\@[a-z]+\\.[a-z]{2,}')
        this.validateUser = aux.test(this.username) ? 'correct' : 'incorrect'
        this.responseUser = aux.test(this.username)
          ? ''
          : 'Ingresa un correo válido. Ex: ejemplo@abc.com'
        return aux.test(this.username)
      } else if (atr === 'emailInc') {
        this.validateUser = 'incorrect'
        this.responseUser = 'Correo ya registrado'
      }
    },
    validateNumber() {
      let validated = this.telephone.length === 9
      this.validatePhone = validated ? 'correct' : 'incorrect'
      this.responsePhone = validated ? '' : 'El telefono debe tener 9 digitos'
      return validated
    },
    validateSex() {
      console.log(this.sexo, this.sexo == 0)
      this.validateGenre = !(this.sexo == 0) ? 'correct' : 'incorrect'
      this.responseGenre = !(this.sexo == 0)
        ? ''
        : 'Debes seleccionar un género.'
      return !(this.sexo == 0)
    },
    validateBday() {
      console.log(this.date)
      console.log(parseInt(this.date))
      let aux = new Date()
      let date =
        parseInt(this.date) >= 1900 &&
        aux.getFullYear() - parseInt(this.date) >= 18
      this.validateDate = date ? 'correct' : 'incorrect'
      this.responseDate = date ? '' : 'Ingrese una fecha correcta.'
      console.log('salio del validateBday')
      return date
    },
    validatePassword(atr) {
      if (atr === 'pass') {
        this.validatePass =
          this.password.length < 8 || this.password.length > 20
            ? 'incorrect'
            : 'correct'
        this.responsePass =
          this.password.length < 8 || this.password.length > 20
            ? 'La contraseña debe tener entre 8 y 20 carácteres.'
            : ''
        return !(this.password.length < 8 || this.password.length > 20)
      } else if (atr === 'check') {
        this.validateCheck =
          this.checkPassword.length < 8 || this.checkPassword.length > 20
            ? 'incorrect'
            : 'correct'
        this.responseCheck =
          this.checkPassword.length < 8 || this.checkPassword.length > 20
            ? 'La contraseña debe tener entre 8 y 20 carácteres.'
            : ''
        return !(
          this.checkPassword.length < 8 || this.checkPassword.length > 20
        )
      }
    },
    validate2Password() {
      let aux = this.password === this.checkPassword
      console.log('aux', aux)
      this.validatePass = aux ? 'correct' : 'incorrect'
      this.validateCheck = aux ? 'correct' : 'incorrect'
      this.response2Pass = aux
        ? ''
        : 'Las contraseñas deben ser iguales. Por favor, intenta de nuevo.'
      return aux
    }
  }
}
</script>




// WEBPACK FOOTER //
// CreateAccount.vue?25bbbcf3